import getExtensionFromPath from '../../getExtensionFromPath'

const isHLSVideo = (src: string | null) =>
  !src ? false : getExtensionFromPath(src) === 'm3u8'

export default isHLSVideo
